export function SuggestionCard({ title, body }) {
    return (
        <div className="suggestion-card">
            <p className="suggestion-title">{title}</p>
            <p className="suggestion-body">{body}</p>
        </div>
    );
}